import { Link } from "react-router-dom";
import { stats } from "@/mocks/site";

export default function HeroSection() {
  return (
    <section
      aria-labelledby="hero-heading"
      className="relative w-full overflow-hidden border-b border-background-200 bg-background-50"
    >
      <div className="mx-auto grid w-full max-w-[1400px] grid-cols-1 gap-12 px-4 py-14 md:px-8 md:py-20 lg:grid-cols-12 lg:items-center">
        <div className="animate-rise lg:col-span-7">
          <p className="label-caps text-[11px] text-primary-600">
            事件复盘 · 深度解读 · 内幕解析
          </p>
          <h2
            id="hero-heading"
            className="mt-5 font-heading text-3xl font-black leading-[1.28] text-foreground-950 md:text-4xl lg:text-[3.25rem]"
          >
            热搜会过去，
            <br className="hidden sm:block" />
            但事情是怎么发生的，值得被理清楚。
          </h2>
          <p className="mt-6 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
            15黑料网把一件复杂的事拆成四步：先还原时间线，再标出关键角色，然后列出还没解释的疑点，最后做一次可以
            被推翻的逻辑复盘。我们不做情绪判断，只帮你把事情看清楚。
          </p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <Link
              to="/analysis"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
            >
              浏览全部深度解读
              <i className="ri-arrow-right-line" aria-hidden="true" />
            </Link>
            <Link
              to="/#methodology"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-6 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700 cursor-pointer"
            >
              我们如何解读
            </Link>
          </div>

          <dl className="mt-11 grid grid-cols-2 gap-x-6 gap-y-7 border-t border-background-200 pt-7 sm:grid-cols-4">
            {stats.map((item) => (
              <div key={item.label}>
                <dt className="font-heading text-xl font-black text-foreground-950 md:text-2xl">
                  {item.value}
                </dt>
                <dd className="mt-1.5 text-xs leading-relaxed text-foreground-500">
                  {item.label}
                </dd>
              </div>
            ))}
          </dl>
        </div>

        <div className="lg:col-span-5">
          <div className="relative h-[280px] w-full overflow-hidden rounded-lg border border-background-200 sm:h-[360px] lg:h-[460px]">
            <img
              src="https://readdy.ai/api/search-image?query=abstract%20editorial%20investigation%20concept%20on%20warm%20cream%20paper%20background%2C%20scattered%20documents%2C%20thin%20crimson%20timeline%20lines%20and%20amber%20marker%20shapes%2C%20magnifying%20glass%20silhouette%2C%20cinematic%20soft%20lighting%2C%20flat%20graphic%20collage%20style%2C%20no%20text&width=1200&height=1400&seq=hero-investigate-15&orientation=portrait"
              alt="事件深度解读与真相挖掘主题的抽象插图"
              title="15黑料网 - 事件深度解读与真相挖掘"
              className="h-full w-full object-top object-cover"
            />
            <div className="absolute bottom-3 left-3 right-3 rounded-md bg-background-50/95 px-4 py-3 backdrop-blur">
              <p className="label-caps text-[10px] text-accent-700">每篇固定结构</p>
              <p className="mt-1.5 text-xs leading-relaxed text-foreground-700">
                时间线 · 关键角色 · 疑点清单 · 逻辑复盘
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}